import React, { useState } from 'react'
import OutsideClickHandler from 'react-outside-click-handler'

import Menu from '../components/Menu'

export default ({ align, children }) => {
    const [isOpen, setIsOpen] = useState(false)

    function toggle() {
        setIsOpen(!isOpen)
    }
    function close() {
        setIsOpen(false)
    }

    return (
        <div className="actions us-n">
            <OutsideClickHandler onOutsideClick={close}>
                <ul className={`btn ${isOpen ? 'is-active' : ''}`} onClick={toggle}>
                    <span></span>
                    <span></span>
                    <span></span>
                </ul>
                <Menu show={isOpen} align={align}>
                    {children}
                </Menu>
            </OutsideClickHandler>
        </div>
    )
}
